export type TimeFormat = '12h' | '24h'

export type UIConfiguration = {
    fontSizePercentage: number
    isHeaderHidden: boolean
    isFullWidthMode: boolean
    shouldDisplayLogo: boolean
    isTimestampFormatsEnabled: boolean
    isShowSpeakerColorCodeEnabled: boolean
    shouldShowTranscriptInAllCaps: boolean
    isEditingLocked: boolean
    timeFormat: TimeFormat
}

export const FONT_SIZE_PERCENTAGE_DEFAULT = 100
export const FONT_SIZE_PERCENTAGE_OPTIONS = [100, 110, 125, 150, 175, 200, 300, 400, 500]
export const FONT_SIZE_BASE = 16

/** The transcript's font size in whole pixels, as rendered. */
export const getTranscriptFontSize = (fontSizePercentage: number) => Math.round((FONT_SIZE_BASE * fontSizePercentage) / 100)

/** The rendered font size over the default, for elements that scale with the transcript text. */
export const getTranscriptFontScale = (fontSizePercentage: number) => getTranscriptFontSize(fontSizePercentage) / FONT_SIZE_BASE
